<template lang='pug'>
  .member-header-node
    .member-header(v-if='isMobile')
      .banner(v-lazy:background-image='this.bannerUrl' :title='this.altText')
        .loader-spinner
        .title(v-t='"account.rewardsBoutique.memberHeader.rewardObsession"' :class='{ "hidden": this.bannerUrl }')
        .subtitle(v-t='"account.rewardsBoutique.memberHeader.morePerks"' :class='{ "hidden": this.bannerUrl }')
      MemberDetails(:member="member")
    .member-header(v-else v-lazy:background-image='this.bannerUrl' :title='this.altText')
      .banner(:title='this.altText')
        .loader-spinner
        .title(v-t='"account.rewardsBoutique.memberHeader.rewardObsession"' :class='{ "hidden": this.bannerUrl }')
        .subtitle(v-t='"account.rewardsBoutique.memberHeader.morePerks"' :class='{ "hidden": this.bannerUrl }')
      MemberDetails(:member="member")
</template>

<script>

import MemberDetails from './member-details.vue'

export default {
  name: 'MemberHeader',

  components: {
    MemberDetails
  },

  props: {
    member: Object
  },

  data () {
    return {
      bannerUrl: '',
      altText: ''
    }
  },

  created () {
    this.headerSectionBannerImageUrl()
  },

  computed: {
    isMobile: () => vueSupport.isMobile
  },

  methods: {
    headerSectionBannerImageUrl () {
      const platform = this.isMobile ? 'mobile' : 'desktop'
      const url = `/api/v2.5/billboards/rewards_boutique_banner_url?filter[platform]=${platform}`
      return window.axios.get(url).then((response) => {
        this.bannerUrl = response.data.data.attributes['banner-url']
        this.altText = response.data.data.attributes['alt-text']
        $('.loader-spinner').hide()
      }).catch(() => {})
    }
  }
}
</script>

<style lang='scss' scoped>
  @mixin rewards-bg {
    background-image: url('../../assets/images/account/rewards-boutique/banner.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .member-header {
    @include media-breakpoint-up(sm) {
      @include rewards-bg;
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;

      @include media-breakpoint-up(sm) {
        align-items: center;
        min-height: 140px;
        margin-bottom: 30px;
      }

      @include media-breakpoint-up(lg) {
        min-height: 200px;
      }
    }

    > .banner {
      @include rewards-bg;
      min-height: 100px;
      color: $white;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @include media-breakpoint-up(sm) {
        background: none;
        flex-grow: 1;
      }
    }
  }

  .banner {
    margin-bottom: 16px;
    > .title {
      @include font-sephora-serif;
      text-transform: capitalize;
      font-size: 24px;
      line-height: 36px;

      @include media-breakpoint-up(sm) {
        font-size: 28px;
      }

      @include media-breakpoint-up(lg) {
        font-size: 46px;
        line-height: 60px;
      }
    }

    > .subtitle {
      font-size: 13px;

      @include media-breakpoint-up(lg) {
        font-size: 16px;
      }
    }
  }

  .hidden {
    visibility: hidden;
  }

  .loader-spinner {
    margin: 0 auto;
    position: static;
  }
</style>
